const items = [
  {
    icon: "ri-time-line",
    label: "Intervention 24h",
    desc: "Urgence et dépannage",
  },
  {
    icon: "ri-file-list-3-line",
    label: "Devis gratuit",
    desc: "Sans engagement",
  },
  {
    icon: "ri-shield-check-line",
    label: "Toutes marques",
    desc: "Somfy, Nice et autres",
  },
  {
    icon: "ri-award-line",
    label: "Garantie 10 ans",
    desc: "Pièces et main d'œuvre",
  },
];

export default function Reassurances() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div
              key={item.label}
              className="bg-white rounded-xl border border-brand-border p-5 md:p-6 flex flex-col items-center text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-light mb-3">
                <i className={`${item.icon} text-brand-cyan text-xl`}></i>
              </div>
              <p className="text-brand-blue text-base font-bold mb-1">{item.label}</p>
              <p className="text-brand-text text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}